import http from '@/plugins/http';

export default (customerId) => new Promise((res, rej) => {
  const dateBegin = new Date();
  const dateEnd = new Date();
  dateEnd.setFullYear(dateEnd.getFullYear() + 2);
  http.get(`/v3/customers/${customerId}/stats?date_begin=${dateBegin.toISOString()}&date_end=${dateEnd.toISOString()}&statistics[]=missionCount`)
    .then((response) => {
      const results = response.data.mission_count;
      res(results);
    })
    .catch((error) => {
      rej(error);
    });
});
